import type { InvoiceRequirements } from "@/app/services/generated/invoicerulesService";
import { invoiceRulesService } from "@/app/services/generated/invoicerulesService";
import userStore from "@/store/modules/userStore";
import { reactive, readonly, watch } from "vue";

interface InvoiceConfigurationStoreState {
  invoiceRequirements: InvoiceRequirements | null;
}

const state = reactive<InvoiceConfigurationStoreState>({
  invoiceRequirements: null,
});

const refreshStore = async () => {
  [state.invoiceRequirements] = await Promise.all([
    invoiceRulesService.getInvoiceRequirements(),
  ]);
};

watch(
  () => userStore.state.tenant,
  async () => {
    if (userStore.state.tenant) {
      await refreshStore();
    }
  },
  { immediate: true }
);

export default {
  state: readonly(state),
  refreshStore,
};
